import type { ActionFeedbackKind } from '../../types'
import type { ActionFeedbackProps } from './ActionFeedback.types'

// Presentation for each outcome kind. Conflict and not-found are warnings (amber)
// rather than errors — they are expected, actionable states, not failures.
const PRESENTATION: Record<
  ActionFeedbackKind,
  { alertClass: string; title: string }
> = {
  success: { alertClass: 'alert-success', title: 'Request accepted' },
  conflict: { alertClass: 'alert-warning', title: 'Build already in progress' },
  notFound: { alertClass: 'alert-warning', title: 'Not found' },
  error: { alertClass: 'alert-danger', title: 'Request failed' },
}

export function ActionFeedback({ feedback }: ActionFeedbackProps) {
  if (!feedback) {
    return null
  }

  const { alertClass, title } = PRESENTATION[feedback.kind]

  return (
    <div className={`alert ${alertClass}`} role="alert">
      <strong>{title}:</strong> {feedback.message}
    </div>
  )
}
